import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const moduleStyles = [
  ['square', 'Square', FiIcons.FiSquare],
  ['rounded', 'Rounded', FiIcons.FiBox],
  ['dots', 'Dots', FiIcons.FiCircle],
  ['godly', 'Godly', FiIcons.FiStar],
  ['godly-round', 'Godly Round', FiIcons.FiStar],
  ['extra-round', 'Extra Round', FiIcons.FiCircle]
];

const outerCorners = [
  ['square', 'Square', FiIcons.FiSquare],
  ['rounded', 'Rounded', FiIcons.FiBox],
  ['circle', 'Circle', FiIcons.FiCircle]
];

const innerEyes = [
  ['square', 'Square', FiIcons.FiSquare],
  ['dot', 'Dot', FiIcons.FiCircle]
];

function StyleChoices({ options, value, onChange }) {
  return (
    <div className="choice-grid">
      {options.map(([id, label, icon]) => (
        <button
          className={value === id ? 'active' : ''}
          key={id}
          onClick={() => onChange(id)}
          type="button"
        >
          <SafeIcon icon={icon} />
          <span>{label}</span>
        </button>
      ))}
    </div>
  );
}

function StylesTab({ design, update }) {
  return (
    <div className="design-tab-content styles-tab">
      <div className="style-control">
        <label className="field-label">Styles</label>
        <StyleChoices
          options={moduleStyles}
          value={design.moduleStyle || design.shape}
          onChange={(value) => update('moduleStyle', value)}
        />
      </div>

      <div className="style-control">
        <label className="field-label">Outer corner bracket</label>
        <StyleChoices
          options={outerCorners}
          value={design.outerCorner || 'square'}
          onChange={(value) => update('outerCorner', value)}
        />
      </div>

      <div className="style-control">
        <label className="field-label">Inner corner eye</label>
        <StyleChoices
          options={innerEyes}
          value={design.innerEye || 'square'}
          onChange={(value) => update('innerEye', value)}
        />
      </div>
    </div>
  );
}

export default StylesTab;